export const setTitle = (title?: string) => {
  let titleArray = ["CyTrain"];
  if (title) titleArray.unshift(title);
  document.title = titleArray.join(" | ");
};

export const mapUrlToName = (url: string) => {
  switch (url) {
    case "lectures":
      return "講座";
    case "tests":
      return "確認テスト";
    case "about":
      return "このサイトについて";
    default:
      return "";
  }
};
